import { render, staticRenderFns } from "./edit-role.vue?vue&type=template&id=f681b434&"
import script from "./edit-role.vue?vue&type=script&lang=ts&"
export * from "./edit-role.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "edit-role.vue"
export default component.exports